import { useMemo } from 'react';
import type { MetricsDatasetV2Response } from '@data/hooks/api/use-metrics-dataset-v2-api/use-metrics-dataset-v2-api';
import { buildAssessmentPeriodMonths } from '@data/utils/build-assessment-period-months';
import { pivotDatasetForProficiencyGraph } from '@data/utils/pivot-dataset-for-proficiency-graph';

interface UseReportProficiencyGraphPropsOptions {
  xFieldKey?: string;
  yFieldKey?: string;
}

export function useReportProficiencyGraphProps(
  data: MetricsDatasetV2Response | undefined,
  {
    xFieldKey = 'assessment_period',
    yFieldKey = 'student_count',
  }: UseReportProficiencyGraphPropsOptions = {}
) {
  const { rows, proficiencyOrder, presentAssessmentPeriods } = useMemo(
    () => pivotDatasetForProficiencyGraph(data),
    [data]
  );

  const assessmentPeriodMonths = useMemo(
    () => buildAssessmentPeriodMonths(data),
    [data]
  );

  const axisLabels = useMemo(
    () => ({
      x: data?.fields?.find((f) => f.key === xFieldKey)?.label ?? '',
      y: data?.fields?.find((f) => f.key === yFieldKey)?.label ?? '',
    }),
    [data, xFieldKey, yFieldKey]
  );

  return {
    rows,
    proficiencyOrder,
    presentAssessmentPeriods,
    assessmentPeriodMonths,
    axisLabels,
  };
}
